import { z } from 'zod';

// Schema for creating a new invite
export const createInviteSchema = z.object({
  name: z.string().min(1, 'Invite name is required'),
  description: z.string().optional().nullable(),
  coupon_id: z.number().optional().nullable(),
});

export type CreateInviteFormData = z.infer<typeof createInviteSchema>;

// Schema for editing an existing invite
export const editInviteSchema = z.object({
  name: z.string().min(1, 'Invite name is required'),
  description: z.string().optional().nullable(),
  coupon_id: z.number().optional().nullable(),
  is_active: z.boolean(),
});

export type EditInviteFormData = z.infer<typeof editInviteSchema>;

// Schema for assigning invite to a user
export const assignInviteSchema = z.object({
  user_id: z.number({
    required_error: 'Please select a user',
  }),
  quantity: z
    .number({
      required_error: 'Quantity is required',
      invalid_type_error: 'Quantity must be a number',
    })
    .min(1, 'Quantity must be at least 1'),
  notes: z.string().optional().nullable(),
});

export type AssignInviteFormData = z.infer<typeof assignInviteSchema>;

// Schema for editing an allocation
export const editAllocationSchema = z.object({
  quantity_allocated: z
    .number({
      required_error: 'Quantity is required',
      invalid_type_error: 'Quantity must be a number',
    })
    .min(0, 'Quantity must be a positive number'),
  notes: z.string().optional().nullable(),
});

export type EditAllocationFormData = z.infer<typeof editAllocationSchema>;

// Helper function to create edit allocation schema with dynamic min
export const createEditAllocationSchema = (minQuantity: number) =>
  z.object({
    quantity_allocated: z
      .number({
        required_error: 'Quantity is required',
        invalid_type_error: 'Quantity must be a number',
      })
      .min(minQuantity, `Quantity cannot be less than ${minQuantity} (already used)`),
    notes: z.string().optional().nullable(),
  });
